import CommonModal from 'components/common/CommonModal';
import ScreenLayout from 'components/common/ScreenLayout';
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {colors} from 'styles/colors';
import {minmax} from 'utils/minmax';
import DefaultText from 'components/common/DefaultText';
import Pagination from 'components/common/Pagination';
import moment from 'moment-timezone';
import {useNavigate} from 'react-router-dom';
import {useRecoilValue} from 'recoil';
import {userInfoState} from 'utils/Atoms';
import {
  searchBackOfficeTongPlace,
} from 'function/api';
import {convertTotalPage} from 'function/converter';
import {formatPhoneNumber} from 'utils/fomatPhoneNumber';
import BusinessImgModal from 'components/main/BusinessImgModal';
import ChangeStateModal from 'components/main/ChangeStateModal';
import {ResponseSearchBackOfficeTongPlace} from 'interfaces/interface';
import {formatBusinessRegisterNumber} from 'function/formatter';
import ContainerHeader from 'components/common/ContainerHeader';

/**
 * 결제 실패 현장 목록 페이지 컴포넌트
 * 결제 실패 현장 목록을 조회하는 페이지입니다.
 * @returns {JSX.Element} 결제 실패 현장 목록 페이지 컴포넌트
 */
const PaymentFailure = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorModal, setErrorModal] = useState({});

  const navigate = useNavigate();

  const userInfo = useRecoilValue(userInfoState);

  const [tongCurrentPage, setTongCurrentPage] = useState(1);
  const [tongTotalPage, setTongTotalPage] = useState(1);

  const [tongData, setTongData] =
    useState<null | ResponseSearchBackOfficeTongPlace>(null);

  const [modal, setModal] = useState('');

  const [selectItem, setSelectItem] = useState<null | any>(null);

  const modalData: {[key: string]: any} = {
    // 본사시스템 서비스 준비중
    servicePreparing: {
      title: 'servicePreparing',
      firstButtonText: 'confirm',
      firstButtonClick: () => {
        setModal('');
      },
    },
  };

  useEffect(() => {
    if (!userInfo?.accessToken) {
      navigate('/');
    }
  }, []);

  // 임시!!!
  // 현장 리스트 - 사용X / 임시 복원
  // create 어쩌구로 조회되는 api 따로 필요
  useEffect(() => {
    if (userInfo?.accessToken) {
      searchBackOfficeTongPlace({
        userInfo,
        setErrorModal,
        setIsLoading,
        page: tongCurrentPage,
      }).then(result => {
        if (result) {
          setTongData(result);

          const resTotalPage = convertTotalPage(result.totalCount ?? 0, 10);
          setTongTotalPage(resTotalPage);
        }
      });
    }
  }, [userInfo, tongCurrentPage]);

  return (
    <ScreenLayout isLoading={isLoading} errorModal={errorModal}>
      <Container>
        <ContainerHeader
          mainTitle="paymentManagement"
          subTitle="paymentFailure"
        />

        <Inner>
          {/* 결제 실패 현장 */}
          <DefaultText
            text="현장 리스트"
            textStyle={{
              fontSize: minmax(25),
              fontWeight: 'bold',
              borderBottom: `3px solid ${colors.primary}`,
              width: 'fit-content',
              marginBottom: minmax(20),
            }}
          />
          <ResultArea>
            <ResultHeader>
              <DefaultText
                text=""
                textStyle={{
                  ...ResultHeaderTextStyle,
                  flex: 0.4,
                }}
              />
              <DefaultText
                text="registerDate"
                textStyle={ResultHeaderTextStyle}
              />
              <DefaultText text="applicant" textStyle={ResultHeaderTextStyle} />
              <DefaultText
                text="applicantNumber"
                textStyle={{...ResultHeaderTextStyle, flex: 1.5}}
              />
              <DefaultText
                text="siteName"
                textStyle={{...ResultHeaderTextStyle, flex: 2}}
              />
              <DefaultText
                text="siteAddress"
                textStyle={{...ResultHeaderTextStyle, flex: 2}}
              />
              <DefaultText
                text="businessLicense"
                textStyle={ResultHeaderTextStyle}
              />
              <DefaultText
                text="businessRegistrationNumber"
                textStyle={{...ResultHeaderTextStyle, flex: 1.5}}
              />
              <DefaultText
                text="DUNS"
                textStyle={{...ResultHeaderTextStyle, flex: 1.5}}
              />
              <DefaultText
                text="onsitePhoneNumber"
                textStyle={{...ResultHeaderTextStyle, flex: 1.5}}
              />
              {/* <DefaultText text="state" textStyle={ResultHeaderTextStyle} /> */}
            </ResultHeader>

            <ResultList>
              {tongData?.totalCount ? (
                tongData.tongPlaceList.map((item: any, index: number) => (
                  <ResultItem
                    key={item.uuid}
                    onClick={() => {
                      // 각 현장 결제 관리로 이동
                      navigate(`/paymentFailureTongPlace`, {
                        state: {uuid: item.uuid},
                      });
                    }}>
                    <DefaultText
                      text={((tongCurrentPage - 1) * 10 + index + 1).toString()}
                      textStyle={{...ResultHeaderTextStyle, flex: 0.4}}
                    />
                    <DefaultText
                      text={moment(item.createdAt).format('YY-MM-DD')}
                      textStyle={ResultItemStyle}
                    />
                    <DefaultText
                      text={item.owner.profile?.name || '-'}
                      textStyle={ResultItemStyle}
                    />
                    <DefaultText
                      text={formatPhoneNumber({
                        phone: item.owner.phone,
                        locale: item.owner.locale,
                      })}
                      textStyle={{...ResultItemStyle, flex: 1.5}}
                    />
                    <DefaultText
                      text={item.name}
                      textStyle={{...ResultItemStyle, flex: 2}}
                    />
                    <DefaultText
                      text={
                        item.address +
                        (item.addressDetail ? ', ' + item.addressDetail : '')
                      }
                      textStyle={{...ResultItemStyle, flex: 2}}
                    />
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flex: 1,
                      }}>
                      {item.businessRegisterNumberImg ? (
                        <DefaultText
                          text={'확인하기'}
                          textStyle={{
                            width: 'fit-content',
                            cursor: 'pointer',
                            backgroundColor: colors.primary2,
                            color: colors.white,
                            borderRadius: minmax(10),
                            padding: minmax(10),
                          }}
                          onClick={() =>
                            setSelectItem({...item, type: 'tong-places'})
                          }
                        />
                      ) : (
                        '-'
                      )}
                    </div>
                    <DefaultText
                      text={formatBusinessRegisterNumber(
                        item.businessRegisterNumber,
                      )}
                      textStyle={{...ResultItemStyle, flex: 1.5}}
                    />
                    <DefaultText
                      text={item.dunsNumber || '-'}
                      textStyle={{...ResultItemStyle, flex: 1.5}}
                    />
                    <DefaultText
                      text={formatPhoneNumber({
                        phone: item.tongPlaceNumber,
                        locale: item.locale,
                      })}
                      textStyle={{...ResultItemStyle, flex: 1.5}}
                    />
                    {/* <DefaultText
                      text={allowStateStatus[item.allowState].text}
                      textStyle={{
                        ...ResultItemStyle,
                        color: allowStateStatus[item.allowState].color,
                        cursor: 'pointer',
                      }}
                      onClick={() =>
                        setSelectItem({
                          ...item,
                          type: 'tong-places',
                          isState: true,
                        })
                      }
                    /> */}
                  </ResultItem>
                ))
              ) : (
                <DefaultText
                  text="noDataMsgTongList"
                  textStyle={{
                    color: colors.darkGray,
                    textAlign: 'center',
                    margin: `${minmax(12)} 0`,
                  }}
                />
              )}
            </ResultList>
          </ResultArea>

          {tongData?.totalCount ? (
            <Pagination
              totalPage={tongTotalPage}
              currentPage={tongCurrentPage}
              setCurrentPage={setTongCurrentPage}
            />
          ) : null}
        </Inner>
      </Container>

      {modal !== '' && (
        <CommonModal
          title={modalData[modal].title}
          detail={modalData[modal].detail}
          firstButtonText={modalData[modal].firstButtonText}
          firstButtonStyle={modalData[modal].firstButtonStyle}
          secondButtonText={modalData[modal].secondButtonText}
          secondButtonStyle={modalData[modal].secondButtonStyle}
          firstButtonClick={modalData[modal].firstButtonClick}
          secondButtonClick={modalData[modal].secondButtonClick}
          closeModal={modalData[modal].firstButtonClick}
        />
      )}

      {/* 상태 변경 | 사업자등록증 모달 */}
      {selectItem &&
        (selectItem.isState ? (
          <ChangeStateModal
            selectItem={selectItem}
            closeModal={() => setSelectItem(null)}
            setIsLoading={setIsLoading}
            setErrorModal={setErrorModal}
          />
        ) : (
          <BusinessImgModal
            selectItem={selectItem}
            closeModal={() => setSelectItem(null)}
            setIsLoading={setIsLoading}
            setErrorModal={setErrorModal}
          />
        ))}
    </ScreenLayout>
  );
};

export default PaymentFailure;

const Container = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  flex-direction: column;
  margin-bottom: ${minmax(50)};
`;

const Inner = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: ${minmax(20)};
`;

const ResultArea = styled.div`
  margin-bottom: ${minmax(40)};
  border-bottom: 1px solid ${colors.darkGray};
`;

const ResultHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: ${minmax(52)};
  background-color: #f7f7f7;
`;

const ResultList = styled.ul`
  /* height: 728px; */
  /* overflow-y: auto; */

  // 스크롤바 삭제
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
`;

const ResultItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${minmax(8)} 0;
  min-height: ${minmax(52)};
  border-top: 1px solid ${colors.lightGrey};
  cursor: pointer;
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background-color: #f2f2f2;
  }
`;

const ResultHeaderTextStyle: React.CSSProperties = {
  flex: 1,
  textAlign: 'center',
  color: '#585858',
};

const ResultItemStyle: React.CSSProperties = {
  flex: 1,
  textAlign: 'center',
  // overflow: 'hidden',
  // textOverflow: 'ellipsis',
  // whiteSpace: 'nowrap',
  // wordBreak: 'break-all',
};
